import { Avatar, Card, Grid2, Stack } from '@mui/material'
import { memo } from 'react'

import stakingIcon from 'assets/staking-coin.png'
import balanceIcon from 'assets/symbol-coin.png'
import { TIER_STAKING_REWARD } from 'src/constants/staking'
import { CURRENCIES, formatQBXCurrency } from 'src/util/staking/staking.helpers'
import { formatTicks } from 'src/util/string.helpers'
import NextPaymentTimer from '../common/NextPaymentTimer'
import CardHeading from '../shared/text/CardHeading'
import Text from '../shared/text/Text'
import ClaimStakingRewardCard from './ClaimStakingRewardCard'

const StakingReward = ({
  t,
  onClaimReward,
  tier,
  stakingProfile: { stakingReward, error, claimSymbolInfo },
  symbol,
  stakingSymbolReward
}) => {
  const errorMsg = error?.stakingReward
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{ justifyContent: 'space-between', alignItems: 'center' }}
      >
        <CardHeading title={t('brand:staking.staking-reward')} noMargin />
        <Text
          label={
            <>
              {t('brand:staking.next-distribution')}
              <NextPaymentTimer />
            </>
          }
        />
      </Stack>
      <Grid2 container spacing={2} mt={1}>
        <Grid2 size={{ xs: 12, sm: 12, md: 5.5 }}>
          <ClaimStakingRewardCard
            t={t}
            tier={tier}
            value={formatQBXCurrency(stakingReward)}
            symbol={CURRENCIES.QBX}
            icon={stakingIcon}
            onClaimReward={onClaimReward}
            bonusCondition={`${TIER_STAKING_REWARD[tier.id]}% ${t('brand:staking.apy')}`}
            disableAction={stakingReward <= 0}
          />
        </Grid2>

        <Grid2
          size={{ xs: 12, sm: 12, md: 1 }}
          display='flex'
          justifyContent='center'
          alignItems='center'
        >
          <Avatar
            sx={{
              width: 48,
              height: 48,
              color: 'primary.main',
              bgcolor: 'background.neutral',
              mx: 'auto',
              typography: 'body1',
              fontWeight: 700,
              textTransform: 'uppercase'
            }}
          >
            {t('common.or')}
          </Avatar>
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 12, md: 5.5 }}>
          <ClaimStakingRewardCard
            t={t}
            tier={tier}
            value={`${formatTicks(stakingSymbolReward)} ${symbol}`}
            symbol={symbol}
            icon={balanceIcon}
            onClaimReward={onClaimReward}
            bonusCondition={t(
              `brand:staking.status-${tier.id === 1 ? 'unavailable' : 'available'}`
            )}
            disableAction={
              !stakingSymbolReward > 0 ||
              claimSymbolInfo.pendingTransactions > 0
            }
          />
        </Grid2>
      </Grid2>
      {errorMsg && <Text label={t(errorMsg)} color='error' />}
    </Card>
  )
}

export default memo(StakingReward)
